// EmailJS Configuration
// Replace these values with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
  PUBLIC_KEY: "D9UAEzgII2nawhGT8",
  SERVICE_ID: "service_zcb0hyje",
  TEMPLATE_ID: "template_4gizjgb",
};

// Example:
// export const EMAILJS_CONFIG = {
//   PUBLIC_KEY: "user_abc123def456",
//   SERVICE_ID: "service_abc123",
//   TEMPLATE_ID: "template_def456",
// }; 